/**************************************** PROJECT MODULES *****************************************/
import {serializationConfig} from './utils/serialization-config';

const {REFERENCE_PROP} = serializationConfig.symbols;
const {getMetadata, defineMetadata} = Reflect;

/********************************************* EXPORT *********************************************/
/**
 * @decorator referenceProp
 *
 * Content of marked property becomes the "reference" value used to associate the record with
 * its data in storage (localForage).
 * Produces a storage key like e.g. `[RecordModel<a3ca131b-3d79-4372-886b-c2660e7db55d>]`
 *
 * @example To select objectId as a record's reference property:
 *     @referenceProp
 *     @observer
 *     public objectId: string;
 *
 * @param {object} klassProto Object to add reference prop to (an accessor or instance property)
 * @param {string} prop Key whose value will act as the reference prop.
 */
export function referenceProp(target: object, prop: string): void {
    const existingRefProp = getMetadata(REFERENCE_PROP, target.constructor);

    // Throw if referenceProp already defined - only 1 @referenceProp is allowed
    if (existingRefProp && existingRefProp !== prop) {
        throw new Error(
            `Failed to set referenceProp to ${prop}: can only add @referenceProp to 1 store prop`
        );
    }

    // Set reference prop to current "class" (constructor)
    defineMetadata(REFERENCE_PROP, prop, target.constructor);
}
